import { privateAPI } from '.';

export const requestPlusAPI = privateAPI.injectEndpoints({
  endpoints: build => ({
    markRequestPlusAsRead: build.mutation({
      query: ({ projectId } = {}) => ({
        url: '/client-portal/request-plus/mark-as-read',
        method: 'POST',
        body: projectId ? { project_id: projectId } : undefined,
      }),
    }),
  }),
});

export const { useMarkRequestPlusAsReadMutation } = requestPlusAPI;
